import { Button } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  button: {
    color: theme.color.state.stateError,
    '&:hover': {
      '& $icon, & $button': {
        color: theme.color.state.stateErrorDark,
      },
      '& $iconRemove, $buttonRemove': {
        color: theme.color.state.stateErrorDark,
      },
    },
  },
}));

interface DeleteButtonProps {
  deleteHandler: any;
  label: string;
  className?: string;
  buttonId?: any;
}

/**
 * DO NOT add hooks even like useStyles or useTranslation hooks here,
 * as this is being used in data table and will cause invariant violation for
 * rendering different number of hooks when
 * deleting data in data table and cache invalidation/refetch happens at the same time
 */
const DeleteButton = (props: DeleteButtonProps) => {
  const { deleteHandler, label, className, buttonId } = props;
  const { classes } = useStyles();

  return (
    <Button
      id={`button-delete-${buttonId}`}
      variant="text"
      onClick={deleteHandler}
      size="small"
      style={{ padding: 0, minWidth: 0 }}
      className={`${classes.button} ${className} delete-subject-button`}
    >
      <IconWithLabel
        iconSize="M"
        iconName={IconName.trash}
        label={label}
        typographyProps={{
          variant: 'h5',
        }}
      />
    </Button>
  );
};

export default DeleteButton;
